function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask5",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 25,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,3 C3.44771525,3 3,3.44771525 3,4 L3,8 C3,8.55228475 3.44771525,9 4,9 L20,9 C20.5522847,9 21,8.55228475 21,8 L21,4 C21,3.44771525 20.5522847,3 20,3 L4,3 Z M20,13 C21.6568542,13 23,14.3431458 23,16 L23,20 C23,21.6568542 21.6568542,23 20,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,16 C1,14.3431458 2.34314575,13 4,13 L20,13 Z M20,15 L4,15 C3.44771525,15 3,15.4477153 3,16 L3,20 C3,20.5522847 3.44771525,21 4,21 L20,21 C20.5522847,21 21,20.5522847 21,20 L21,16 C21,15.4477153 20.5522847,15 20,15 Z M20,1 C21.6568542,1 23,2.34314575 23,4 L23,8 C23,9.65685425 21.6568542,11 20,11 L4,11 C2.34314575,11 1,9.65685425 1,8 L1,4 C1,2.34314575 2.34314575,1 4,1 L20,1 Z",
  id: "icon",
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mask-icon",
  mask: "url(#mask5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000"
}));

var SvgKanban = function SvgKanban(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKanban, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kanban.b7f78ee3.svg";
export { ForwardRef as ReactComponent };